<section class="littelAngelBg">
  <div class="littelAngelHelpingWidth">
    <div class="littelAngelHelping">
      <h2>Helping Children Thrive: NuLifeSpan Rx and Little Angel Hands</h2>
      <button (click)="newDiscountModal()">Get Your Free Card Now</button>
    </div>
    <img src="../../assets/images/helping_children.png" />
  </div>
</section>

<img src="../../assets/images/seperator.svg" class="hero-seperator" />

<section class="littelAngelWelcomeWd">
  <div class="littelAngelWelcome">
    <h2>Welcome to NuLifeSpan Rx's partnership with Little Angel Hands</h2>
    <p>A non-profit organization dedicated to improving the lives of children and their families.</p>
    <span>We believe that every child deserves the opportunity to thrive and reach their fullest potential. Through our collaboration with NuLifeSpan Rx, we aim to provide additional support and resources to those who need it the most.</span>
  </div>
  <div class="littelAngelWlVideo">
    <img src="../../assets/images/welcome_Rx.jpg">
    <!-- <img src="../../assets/images/play_icon.svg" class="playIcon" id="iconMob"> -->
  </div>
</section>

<section class="littelAngelService">
 <div class="littelAngelServiceWd">
  <div class="littelAngelLiner">
    <h2>Our Services</h2>
    <p>Explore the ways we are giving back to the community.</p>
    <!-- <button class="mobileHidden" (click)="opendonate($event)">Donate Now</button> -->
  </div>
  <div class="littelAngelTherapy">
    <div class="TherapyRow">
      <img src="../../assets/images/Therapy_Modalities.svg">
      <div class="TherapyMod">
      <h2>Therapy Modalities</h2>
      <p>Our dedicated team of professionals provides comprehensive therapy services, including physical therapy, occupational therapy, speech therapy, & more.</p>
      </div>
    </div>
    <div class="TherapyRow">
      <img src="../../assets/images/Durable_Medical.svg">
      <div class="TherapyMod">
      <h2>Durable Medical Equipment</h2>
      <p>We understand the importance of access to reliable and appropriate medical equipment for children with special needs.</p>
      </div>
    </div>
    <div class="TherapyRow">
      <img src="../../assets/images/Affordable_Medication.svg">
      <div class="TherapyMod">
      <h2>Affordable Medication Pricing through NuLifeSpan Rx</h2>
      <p>We recognize the financial challenges families may face when it comes to accessing necessary prescription medications.</p>
      </div>
    </div>
    <!-- <button class="btnMob desktopHidden" (click)="opendonate($event)">Donate Now</button> -->
  </div>
 </div>  
</section>

<section class="littelAngelStories">
  <div class="successStories">
    <h2>Success Stories</h2>
    <p>We are proud to share the heartwarming success stories of children who have thrived under the care and support of Little Angel Hands. From taking their first steps to expressing themselves through words, these stories exemplify the positive impact our services have on children's lives.</p>
  </div>
  <img src = "../../assets/images/success-stories.jpg">
 </section>

 <section class="littelAngelCommunity">
  <img src = "../../assets/images/Community_Involvement.jpg">
  <div class="successStories">
  <h2>Community Involvement</h2>
  <p>Our work wouldn't be possible without the support of our compassionate community. We are grateful to local businesses, individuals, and volunteers who contribute their time, resources, and expertise to help us create a brighter future for children. Together, we are building a community of care, compassion, and support for the children and families we serve.</p>
</div>
</section>

<section class="canHelp">
  <h2>How You Can Help</h2>
  <div class="canHelpMain">
  <div class="canHelpBox">
    <img src="../../assets/images/donate.svg">
    <h5>Donate</h5>
    <p>Your generous donations can make a significant impact on the lives of children in need. By contributing to Little Angel Hands, you are directly supporting the provision of therapy services, durable medical equipment, and other essential resources.</p>
    <!-- <button (click)="opendonate($event)">Donate Now</button> -->
  </div>
  <div class="canHelpBox">
    <img src="../../assets/images/Volunteer.svg">
    <h5>Volunteer</h5>
    <p>We invite you to join our dedicated team of volunteers and make a meaningful difference in the lives of children. Whether you have professional expertise in therapy or simply a compassionate heart, your time and skills are invaluable to us.</p>
    <a href="mailto:support@littleangelhands.org"><button>Volunteer  Now</button></a>
  </div>
 </div>

</section>
 <!-- discount card start -->
 <div class="pharmacyPage newDiscountCardModal printView" *ngIf="newDisCardModal" id="printArea">
  <div class="discount_card"  id="print-section">
    <div class="close_search_pharmacy_popup" (click)="CloseNewCardModal()"></div>

    <div class="discount_card_parent">
      <div class="header">
        <img src="../../assets/images/logo-white-bg.png" alt="" />
        <div class="button_sec">
          <div class="print" (click)="PrintMe()" data-after="Print"></div>
          </div>
        </div>
      
      <div class="pharmacyDetail">
       
        <div class="border-bottom"></div>
        
        <div class="discountModalTxt"><h5>For use at any major retail pharmacy and save!</h5></div>
          <div class="method_salt two">
          <div class="method">
            <div>bin</div>
            <div>023518</div>
          </div>
          <div class="method">
            <div>PCN</div>
            <div>ARX</div>
          </div>
          <div class="method">
            <div>Member ID</div>
            <div>100-4542</div>
          </div>
          <div class="method">
            <div>Group</div>
            <div>{{newCardGroupNo}}</div>
          </div>
        </div>
        <p class="no-insurance pt-0">The NuLifeSpan Rx prescription discount program is free. <span class="strong-text">This is not insurance.</span></p>
        <!-- <div class="email_field" style="position: relative">
          <input type="email" id="email" name="ShareEmail" placeholder=" " [(ngModel)]="UserInputEmail"
            (click)="ClearMessage($event)" (blur)="ClearMessage($event)" (keypress)="clearClassMsg()"
            autocomplete="off" />
          <label for="email">Enter your E-mail</label>
          <div class="sendbtn" (click)="ShareDiscountCard()">Send</div>
          <div class="loadProcess"></div>
        </div> -->
        <span style="color:#f19f57">{{ SendDiscountMessage }}</span>
        <!-- <div class="helpline_btn">
          <div class="helpline" (click)="PharmacyHelpLine()">
            {{ PharmacistHelpline }}
          </div>
          <div class="direction" (click)="RedirectGoogleDirection()">
            Get Directions
            <img src="../../assets/images/direction.svg" alt="" />
          </div>
        </div> -->
      </div>
    </div>
  </div>
 </div>
